import { Controller } from "@hotwired/stimulus"
import { morphChildren } from "@hotwired/turbo"

// Morphs Turbo Frame responses without replacing the active input's value.
// This preserves focus, selection, and edits made while a request is in flight.
export default class extends Controller {
  morph(event) {
    event.detail.render = (currentFrame, newFrame) => {
      morphChildren(currentFrame, newFrame, { ignoreActiveValue: true })
    }
  }
}
